import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer" role="contentinfo" aria-label="Site footer">
      <div className="footer-content">
        <div className="footer-section">
          <p>&copy; {new Date().getFullYear()} Real Time Repairs. All rights reserved.</p>
        </div>
        {/* M6 fix: Added role and aria-label for social links */}
        <div className="footer-social" role="navigation" aria-label="Social media links">
          <a
            href="https://www.facebook.com/profile.php?id=61584112446016"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
            aria-label="Follow us on Facebook"
          >
            <svg className="social-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
            Facebook
          </a>
        </div>
        {/* M6 fix: Added role and aria-label for footer links */}
        <nav className="footer-links" role="navigation" aria-label="Footer navigation">
          <Link to="/terms-of-service" className="footer-link">Terms of Service</Link>
          <span className="footer-separator" aria-hidden="true">|</span>
          <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
          <span className="footer-separator" aria-hidden="true">|</span>
          <Link to="/cookie-policy" className="footer-link">Cookie Policy</Link>
          <span className="footer-separator" aria-hidden="true">|</span>
          <Link to="/contact" className="footer-link">Contact Us</Link>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
